import { backgroundColorConverter, textColorConverter } from "./color-converter.js";
import { getTextColorTextButtons, getTextHighlightTextButtons } from "./getTextButtons.js";
import { tiptapColorBackgroundExtension } from "./tiptap-background.js";
import { tiptapColorForegroundExtension } from "./tiptap-foreground.js";
import { TEXT_COLOR_TYPE, TEXT_HIGHLIGHT_TYPE } from "./types.js";
const pluginTextColor = (config = {}) => {
  return {
    config,
    pmMarkConverters: [textColorConverter],
    pmNodeConverters: [],
    type: TEXT_COLOR_TYPE,
    // @todo: next-major: move tiptapColorBackgroundExtension to pluginTextHighlight
    tiptapExtensions: [tiptapColorForegroundExtension],
    textButtons: getTextColorTextButtons(config)
  };
};
const pluginTextHighlight = (config = {}) => {
  return {
    config,
    pmMarkConverters: [backgroundColorConverter],
    pmNodeConverters: [],
    type: TEXT_HIGHLIGHT_TYPE,
    tiptapExtensions: [tiptapColorBackgroundExtension],
    textButtons: getTextHighlightTextButtons(config)
  };
};
export {
  pluginTextColor,
  pluginTextHighlight
};
//# sourceMappingURL=editor.js.map
